module.exports = __webpack_public_path__ + "static/img/TikTokLogo.4c3ce30e.svg";